export const authTranslations = {
  pt: {
    login: {
      title: "Entrar",
      subtitle: "Acesse sua conta para gerenciar seus links",
      email: { label: "Email", placeholder: "voce@exemplo.com" },
      password: { label: "Senha", placeholder: "••••••••" },
      submit: "Entrar",
      loading: "Entrando...",
      switchPrompt: "Não tem conta?",
      switchCta: "Cadastre-se",
      success: "Login realizado!",
    },
    register: {
      title: "Crie sua conta",
      subtitle: "Crie sua conta e comece grátis",
      name: { label: "Nome", placeholder: "Seu nome" },
      email: { label: "Email", placeholder: "voce@exemplo.com" },
      password: { label: "Senha", placeholder: "Mínimo 6 caracteres" },
      submit: "Cadastrar",
      loading: "Cadastrando...",
      switchPrompt: "Já tem conta?",
      switchCta: "Entrar",
      success: "Cadastro realizado!",
    }
  },
  en: {
    login: {
      title: "Sign in",
      subtitle: "Access your account to manage your links",
      email: { label: "Email", placeholder: "you@example.com" },
      password: { label: "Password", placeholder: "••••••••" },
      submit: "Sign in",
      loading: "Signing in...",
      switchPrompt: "Don't have an account?",
      switchCta: "Sign up",
      success: "Logged in!",
    },
    register: {
      title: "Create your account",
      subtitle: "Create your account and start for free",
      name: { label: "Name", placeholder: "Your name" },
      email: { label: "Email", placeholder: "you@example.com" },
      password: { label: "Password", placeholder: "At least 6 characters" },
      submit: "Sign up",
      loading: "Signing up...",
      switchPrompt: "Already have an account?",
      switchCta: "Sign in",
      success: "Registered!",
    }
  }
};
